import { z } from 'zod';

export const complaintSchema = z.object({
  reportReasonId: z.string(),
  body: z.string(),
});

export type ComplaintFields = z.infer<typeof complaintSchema>;
